import type { SpacerPageBlock } from "@towni/common";
import { pageBlockViewContextFactory } from "../../../page-block-view-context-factory";

const [SpacerPageBlockProvider, useSpacerBlockStore] =
    pageBlockViewContextFactory<SpacerPageBlock>();
export { SpacerPageBlockProvider, useSpacerBlockStore };
